// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.harvest_outcome_enum */
var HarvestOutcomeEnum;
(function (HarvestOutcomeEnum) {
    HarvestOutcomeEnum["OK"] = "OK";
    HarvestOutcomeEnum["ISSUES"] = "ISSUES";
    HarvestOutcomeEnum["FAILED"] = "FAILED";
})(HarvestOutcomeEnum || (HarvestOutcomeEnum = {}));
;
export default HarvestOutcomeEnum;
/** Zod schema for harvest_outcome_enum */
export const harvestOutcomeEnum = z.nativeEnum(HarvestOutcomeEnum);
//# sourceMappingURL=HarvestOutcomeEnum.js.map